import { useState, useEffect } from "react";
import { Route, useNavigate, Routes } from "react-router-dom";
import routes from "../../routes/public";
import { useTranslation } from "react-i18next";
import useCheckCompatibility from "../../hooks/useCheckCompatibility";
import Header from "../../components/Header/Secure";
import Footer from "../../components/Footer";
import { Typography } from "@mui/material";

const customStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  fullPage: {
    display: "flex",
    justifyContent: "center",
    margin: "0",
    flexGrow: 1,
    alignItems: "center",
    padding: "1rem",
    background: "rgba(237, 241, 247, 1)",
  },
  container: {
    width: "75%",
    maxWidth: "700px",
  },
  card: {
    width: "100%",
    height: "100%",
    boxShadow: "0 4px 5px 0 rgba(0, 0, 0, 0.1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: "6px",
    padding: "30px",
  },
  footer: {
    background: "rgba(237, 241, 247, 1)",
    boxShadow: "inset 0px 0px 4px 0px rgb(0 0 0 / 10%)",
  },
};

const Layouts = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(i18n.dir());

  const isNotCompatible = useCheckCompatibility();

  useEffect(() => {
    const authToken = localStorage.getItem("abjadToken");
    if (isNotCompatible) navigate("/device-not-compatible");
    else if (authToken) navigate("/teachers-reports");
    else navigate("/login");
  }, []);

  useEffect(() => {
    setDirection(i18n.dir());
  }, [i18n.dir()]);

  const routeComponents = (
    <Routes>
      {routes.map((route, key) => (
        <Route path={route.path} element={route.element} key={"route" + key} />
      ))}
    </Routes>
  );

  return (
    <Typography component="div" sx={{ ...customStyles.root, direction }}>
      <Header />
      {isNotCompatible ? (
        <Typography
          component="div"
          sx={{ ...customStyles.fullPage, alignItems: "flex-start" }}
        >
          {routeComponents}
        </Typography>
      ) : (
        <>
          <Typography component="div" sx={customStyles.fullPage}>
            <Typography component="div" sx={customStyles.container}>
              <Typography component="div" sx={customStyles.card}>
                {routeComponents}
              </Typography>
            </Typography>
          </Typography>
          <Typography component="div" sx={customStyles.footer}>
            <Footer />
          </Typography>
        </>
      )}
    </Typography>
  );
};

export default Layouts;
